import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || '';

let socket = null;

export const connectSocket = (token) => {
  if (socket?.connected) {
    return socket;
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error.message);
  });

  socket.on('error', (error) => {
    console.error('Socket error:', error);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;

// ==================== GAME ROOM ====================

export const joinGame = (gameId) => {
  if (socket?.connected) {
    socket.emit('join-game', gameId);
  }
};

export const leaveGame = (gameId) => {
  if (socket?.connected) {
    socket.emit('leave-game', gameId);
  }
};

// ==================== TYPING INDICATORS ====================

export const startTyping = (gameId) => {
  if (socket?.connected) {
    socket.emit('typing-start', gameId);
  }
};

export const stopTyping = (gameId) => {
  if (socket?.connected) {
    socket.emit('typing-stop', gameId);
  }
};

// ==================== GAME EVENTS ====================

export const emitMessage = (gameId, message) => {
  if (socket?.connected) {
    socket.emit('message-sent', { gameId, message });
  }
};

export const emitTurnChange = (gameId, turnState, previousPlayer, currentPlayer) => {
  if (socket?.connected) {
    socket.emit('turn-changed', { gameId, turnState, previousPlayer, currentPlayer });
  }
};

export const emitDiceRoll = (gameId, roll, username, characterName) => {
  if (socket?.connected) {
    socket.emit('dice-rolled', { gameId, roll, username, characterName });
  }
};

export const emitGameUpdate = (gameId, update) => {
  if (socket?.connected) {
    socket.emit('game-update', { gameId, update });
  }
};

export const emitTurnWarning = (gameId, userId, secondsLeft) => {
  if (socket?.connected) {
    socket.emit('turn-warning', { gameId, userId, secondsLeft });
  }
};

export const emitTurnTimeout = (gameId, previousUserId, newTurnState) => {
  if (socket?.connected) {
    socket.emit('turn-timeout', { gameId, previousUserId, newTurnState });
  }
};

// ==================== EVENT LISTENERS ====================

export const onPlayerJoined = (callback) => {
  socket?.on('player-joined', callback);
  return () => socket?.off('player-joined', callback);
};

export const onPlayerLeft = (callback) => {
  socket?.on('player-left', callback);
  return () => socket?.off('player-left', callback);
};

export const onPlayerKicked = (callback) => {
  socket?.on('player-kicked', callback);
  return () => socket?.off('player-kicked', callback);
};

export const onPlayerBanned = (callback) => {
  socket?.on('player-banned', callback);
  return () => socket?.off('player-banned', callback);
};

export const onPlayerDisconnected = (callback) => {
  socket?.on('player-disconnected', callback);
  return () => socket?.off('player-disconnected', callback);
};

export const onUserTyping = (callback) => {
  socket?.on('user-typing', callback);
  return () => socket?.off('user-typing', callback);
};

export const onUserStoppedTyping = (callback) => {
  socket?.on('user-stopped-typing', callback);
  return () => socket?.off('user-stopped-typing', callback);
};

export const onNewMessage = (callback) => {
  socket?.on('new-message', callback);
  return () => socket?.off('new-message', callback);
};

export const onTurnUpdate = (callback) => {
  socket?.on('turn-update', callback);
  return () => socket?.off('turn-update', callback);
};

export const onDiceResult = (callback) => {
  socket?.on('dice-result', callback);
  return () => socket?.off('dice-result', callback);
};

export const onGameStateUpdate = (callback) => {
  socket?.on('game-state-update', callback);
  return () => socket?.off('game-state-update', callback);
};

export const onGameState = (callback) => {
  socket?.on('game-state', callback);
  return () => socket?.off('game-state', callback);
};

export const onTurnTimerWarning = (callback) => {
  socket?.on('turn-timer-warning', callback);
  return () => socket?.off('turn-timer-warning', callback);
};

export const onTurnAutoEnded = (callback) => {
  socket?.on('turn-auto-ended', callback);
  return () => socket?.off('turn-auto-ended', callback);
};

export default {
  connectSocket,
  disconnectSocket,
  getSocket,
  joinGame,
  leaveGame,
  startTyping,
  stopTyping,
  emitMessage,
  emitTurnChange,
  emitDiceRoll,
  emitGameUpdate,
  emitTurnWarning,
  emitTurnTimeout,
  onPlayerJoined,
  onPlayerLeft,
  onPlayerKicked,
  onPlayerBanned,
  onPlayerDisconnected,
  onUserTyping,
  onUserStoppedTyping,
  onNewMessage,
  onTurnUpdate,
  onDiceResult,
  onGameStateUpdate,
  onGameState,
  onTurnTimerWarning,
  onTurnAutoEnded
};
